import { useTranslation } from "react-i18next";
import { Badge, type BadgeProps } from "../ui";
import { quoteStatusTone } from "../../features/quotes/statusTones";

interface QuoteStatusBadgeProps {
  status: string | null | undefined;
  size?: BadgeProps["size"];
  variant?: BadgeProps["variant"];
}

/** Estado de una cotización: tono + etiqueta traducida (nunca el valor crudo). */
export function QuoteStatusBadge({ status, size, variant }: QuoteStatusBadgeProps) {
  const { t } = useTranslation("finanzasOperativas");
  const label = status ? t(`quotes.statuses.${status}`, { defaultValue: status }) : t("quotes.statuses.unknown");
  return (
    <Badge tone={quoteStatusTone(status)} size={size} variant={variant}>
      {label}
    </Badge>
  );
}
